module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/master/district/district-view/district-view.component.css
// module id = ./src/app/master/district/district-view/district-view.component.css
// module chunks = main